import React, { Component } from 'react';

import {Cam, Text} from './shared/Icons';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

class Unsupported extends Component {

  render() {
    let user = null;

    if (this.props.info) {
      for (let i = 0; i < this.props.info.length; i++) {
        if (this.props.info[i].id === this.props.user) {
          user = this.props.info[i];
          break;
        }
      }
    }

    const localeLogo = 'Logo_' + this.props.locale;

    return (
      <div className="lobby unsupported">
        <div className="lobby-overlay"></div>
        <div className="lobby-overlay-shadow"></div>
        <div className="lobby-content">
          <img className="logo" src={localeLogo + '.png'} />
          <div className="appointment">
            <span style={{fontSize: '3em'}}>:(</span>
          </div>
          <p>
            <FormattedMessage
              id='Client.Unsupported.BrowserNotSupported'
              defaultMessage='Ihr Browser unterstützt die verwendeten Technologien leider nicht.'
              />
          </p>
          <p style={{textTransform: 'none'}}>
            <FormattedMessage
              id='Client.Unsupported.BrowserInstruction'
              defaultMessage='Bitte verwenden Sie {browser1} oder {browser2}.'
              values={{
                browser1: <a style={{textDecoration: 'none', color: 'inherit'}}href="https://www.mozilla.org/de/firefox/new/">Firefox</a>,
                browser2: <a style={{textDecoration: 'none', color: 'inherit'}}href="https://www.google.de/chrome/">Chrome</a>
              }} />
          </p>
          <p style={{
            margin:'10px 30px 0px 30px',
            textTransform:'none'
          }}>
            <FormattedMessage
              id='Client.Unsupported.BrowserDownloadInstruction'
              defaultMessage='Wir empfehlen den folgenden Browser zu installieren:'
            />
          </p>
          <p style={{
            margin:'40px 30px 60px 30px',
            textTransform: 'none',
            fontWeight:'bold'
            }}>
            <a href="https://www.google.de/chrome/"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'inline-block',
              }}
            >
              <img src="chrome.png" style={{maxWidth: '60px', marginBottom: '10px', width: '50vw'}}/><br/>
              <FormattedMessage
                id='Client.Unsupported.BrowserChromeDownload'
                defaultMessage='Google Chrome herunterladen'
              />
            </a>
          </p>
          <p></p>
          {user &&
            <div className="contact">
              <span>
                <FormattedMessage
                  id='Client.Unsupported.HelpMsgContact'
                  defaultMessage='Ihr Kontakt'
                />
              </span>
              <span className="name">{user.name}</span><br/>
              <span>
                <FormattedMessage
                  id='Client.Unsupported.HelpMsgReachable'
                  defaultMessage='ist erreichbar unter'
                />
              </span><br/><br/>
              <span><a style={{textDecoration: 'none', fontSize: '2em', color: 'inherit'}} href={"tel:" + user.phone}>{user.phone}</a></span>
            </div>}
        </div>
      </div>
    )
  }
};

export default Unsupported;


// WEBPACK FOOTER //
// ./src/Unsupported.js